<app-title-bar rootBreadCrumbs="['i18n.core.navigation.vendor-score-card']" titleText="i18n.core.navigation.vendor-score-card-survey"></app-title-bar>
@if (!areParametersValid && !loading) {
  {{ "i18n.base.set-password.invalid-link" | translate }}
}
@if (areParametersValid) {
  <div class="two-fa-wrapper">
    <div class="row">
      <div class="col-lg-4 offset-lg-4 col-md-6 offset-md-3">
        <ejs-stepper stepType="Default" [activeStep]="stepIndex" [linear]="true" (stepClick)="onStepClick($event)">
          <e-steps>
            <e-step [disabled]="isStepDisabled(stepMarketSizeNumber)"></e-step>
            <e-step [disabled]="isStepDisabled(stepSalesStructureNumber)"></e-step>
            <e-step [disabled]="isStepDisabled(stepProductPortfolioNumber)"></e-step>
            <e-step [disabled]="isStepDisabled(stepMarketingAppearanceNumber)"></e-step>
            <e-step [disabled]="isStepDisabled(stepPotentialNumber)"></e-step>
          </e-steps>
        </ejs-stepper>
      </div>
    </div>
    <div class="row mt-4">
      <form [formGroup]="form" class="card col-lg-4 offset-lg-4 col-md-6 offset-md-3">
        @switch (stepIndex) {
          @case (stepMarketSizeNumber) {
            <div formGroupName="marketSize">
              <h3 class="card-header" [innerHTML]="getHtml('i18n.shared.vendor-score-card-row-types.MarketSize')"></h3>
              <div class="mt-2">
                <label for="tam" class="control-label required" [innerHTML]="getHtml('i18n.shared.vendor-score-card-row-types.TAM')"></label>
                <div class="input-wrapper">
                  <input id="tam" type="number" class="form-control input-required input-field-with-unit--wide" formControlName="tam">
                  <span class="multichar-unit">CHF</span>
                  <app-error-messages [control]="form.controls.marketSize.controls.tam"></app-error-messages>
                </div>
              </div>
              <div class="mt-2">
                <label for="currentMarketShares" class="control-label required" [innerHTML]="getHtml('i18n.shared.vendor-score-card-row-types.CurrentMarketShares')"></label>
                <div class="input-wrapper">
                  <input id="currentMarketShares"
                          type="number"
                          class="form-control input-required input-field-with-unit--single-char"
                          formControlName="currentMarketShares">
                  <span class="single-char-unit">%</span>
                  <app-error-messages [control]="form.controls.marketSize.controls.currentMarketShares"></app-error-messages>
                </div>
              </div>
              <div class="button-group">
                <button type="submit" class="btn btn-primary btn-right" [disabled]="!form.controls.marketSize.valid" (click)="next()">
                  Next
                </button>
              </div>
            </div>
          }
          @case (stepSalesStructureNumber) {
            <div formGroupName="salesStructure">
              <h3 class="card-header" [innerHTML]="getHtml('i18n.shared.vendor-score-card-row-types.SalesStructure')"></h3>
              <div class="mt-2">
                <label for="numberOfActiveResellers"
                        class="control-label required"
                        [innerHTML]="getHtml('i18n.shared.vendor-score-card-row-types.NumberOfActiveResellers')">
                </label>
                <input id="numberOfActiveResellers"
                        type="number"
                        class="form-control input-required"
                        formControlName="numberOfActiveResellers">
                <app-error-messages [control]="form.controls.salesStructure.controls.numberOfActiveResellers"></app-error-messages>
              </div>
              <div class="mt-2">
                <label for="numberOfDistributors"
                        class="control-label required"
                        [innerHTML]="getHtml('i18n.shared.vendor-score-card-row-types.NumberOfDistributors')">
                </label>
                <input id="numberOfDistributors" type="number" class="form-control input-required" formControlName="numberOfDistributors">
                <app-error-messages [control]="form.controls.salesStructure.controls.numberOfDistributors"></app-error-messages>
              </div>
              <div class="mt-2">
                <label for="shareOfRevenue" class="control-label required" [innerHTML]="getHtml('i18n.shared.vendor-score-card-row-types.ShareOfRevenue')"></label>
                <div class="input-wrapper">
                  <input id="shareOfRevenue"
                          type="number"
                          class="form-control input-required input-field-with-unit--wide"
                          formControlName="shareOfRevenue">
                  <span class="multichar-unit">%</span>
                  <app-error-messages [control]="form.controls.salesStructure.controls.shareOfRevenue"></app-error-messages>
                </div>
              </div>
              <div class="button-group">
                <button class="btn btn-secondary" (click)="back()">
                  Back
                </button>
                <button type="submit" class="btn btn-primary" [disabled]="!form.controls.salesStructure.valid" (click)="next()">
                  Next
                </button>
              </div>
            </div>
          }
          @case (stepProductPortfolioNumber) {
            <div formGroupName="productPortfolio">
              <h3 class="card-header" [innerHTML]="getHtml('i18n.shared.vendor-score-card-row-types.ProductPortfolio')"></h3>
              <div class="mt-2">
                <label for="numberOfProductCategories" class="control-label required" [innerHTML]="getHtml('i18n.shared.vendor-score-card-row-types.NumberOfProductCategories')"></label>
                <input id="numberOfProductCategories"
                        type="number"
                        class="form-control input-required"
                        formControlName="numberOfProductCategories">
                <app-error-messages [control]="form.controls.productPortfolio.controls.numberOfProductCategories"></app-error-messages>
              </div>
              <div class="mt-2">
                <label for="numberOfProducts" class="control-label required" [innerHTML]="getHtml('i18n.shared.vendor-score-card-row-types.NumberOfProducts')"></label>
                <input id="numberOfProducts"
                        type="number"
                        class="form-control input-required"
                        formControlName="numberOfProducts">
                <app-error-messages [control]="form.controls.productPortfolio.controls.numberOfProducts"></app-error-messages>
              </div>
              <div class="button-group">
                <button class="btn btn-secondary" (click)="back()">
                  Back
                </button>
                <button type="submit" class="btn btn-primary" [disabled]="!form.controls.productPortfolio.valid" (click)="next()">
                  Next
                </button>
              </div>
            </div>
          }
          @case (stepMarketingAppearanceNumber) {
            <div formGroupName="marketingAppearance">
              <h3 class="card-header" [innerHTML]="getHtml('i18n.shared.vendor-score-card-row-types.MarketingAppearance')"></h3>
              <div class="mt-2">
                <label for="totalFollowers" class="control-label required" [innerHTML]="getHtml('i18n.shared.vendor-score-card-row-types.TotalFollowers')"></label>
                <input id="totalFollowers"
                        type="number"
                        class="form-control input-required"
                        formControlName="totalFollowers">
                <app-error-messages [control]="form.controls.marketingAppearance.controls.totalFollowers"></app-error-messages>
              </div>
              <div class="mt-2">
                <label for="percentageRevenueAllocatedForChannelActivities"
                        class="control-label required"
                        [innerHTML]="getHtml('i18n.shared.vendor-score-card-row-types.PercentageRevenueAllocatedForChannelActivities')">
                </label>
                <div class="input-wrapper">
                  <input id="percentageRevenueAllocatedForChannelActivities"
                          type="number"
                          class="form-control input-required input-field-with-unit--wide"
                          formControlName="percentageRevenueAllocatedForChannelActivities">
                  <span class="multichar-unit">%</span>
                  <app-error-messages [control]="form.controls.marketingAppearance.controls.percentageRevenueAllocatedForChannelActivities"></app-error-messages>
                </div>
              </div>
              <div class="button-group">
                <button class="btn btn-secondary" (click)="back()">
                  Back
                </button>
                <button type="submit" class="btn btn-primary" [disabled]="!form.controls.marketingAppearance.valid" (click)="next()">
                  Next
                </button>
              </div>
            </div>
          }
          @case (stepPotentialNumber) {
            <div formGroupName="potential">
              <h3 class="card-header" [innerHTML]="getHtml('i18n.shared.vendor-score-card-row-types.Potential')"></h3>
              <div class="mt-2">
                <label for="projectedNetRevenue" class="control-label required" [innerHTML]="getHtml('i18n.shared.vendor-score-card-row-types.ProjectedNetRevenue')"></label>
                <div class="input-wrapper">
                  <input id="projectedNetRevenue"
                          type="number"
                          class="form-control input-required input-field-with-unit--wide"
                          formControlName="projectedNetRevenue">
                  <span class="multichar-unit">CHF</span>
                  <app-error-messages [control]="form.controls.potential.controls.projectedNetRevenue"></app-error-messages>
                </div>
              </div>
              <div class="mt-2">
                <label for="expectedGrossProfit" class="control-label required" [innerHTML]="getHtml('i18n.shared.vendor-score-card-row-types.ExpectedGrossProfitMargin')"></label>
                <div class="input-wrapper">
                  <input id="expectedGrossProfit"
                          type="number"
                          class="form-control input-required input-field-with-unit--wide"
                          formControlName="expectedGrossProfit">
                  <span class="multichar-unit">%</span>
                  <app-error-messages [control]="form.controls.potential.controls.expectedGrossProfit"></app-error-messages>
                </div>
              </div>
              <div class="mt-2">
                <label for="revenueGoal" class="control-label required" [innerHTML]="getHtml('i18n.shared.vendor-score-card-row-types.RevenueGoal')"></label>
                <div class="input-wrapper">
                  <input id="revenueGoal" type="number" class="form-control input-required input-field-with-unit--wide" formControlName="revenueGoal">
                  <span class="multichar-unit">CHF</span>
                  <app-error-messages [control]="form.controls.potential.controls.revenueGoal"></app-error-messages>
                </div>
              </div>
              <div class="mt-2">
                <label for="paymentTerms" [innerHTML]="getHtml('i18n.shared.vendor-score-card-row-types.PaymentTerms')"></label>
                <div class="input-wrapper">
                  <input id="paymentTerms"
                          type="number"
                          class="form-control input-required input-field-with-unit--wide"
                          formControlName="paymentTerms">
                  <span class="multichar-unit">Days</span>
                  <app-error-messages [control]="form.controls.potential.controls.paymentTerms"></app-error-messages>
                </div>
              </div>
              @if (showButtons) {
                <div class="button-group">
                  <button class="btn btn-secondary" (click)="back()">
                    Back
                  </button>
                  <button type="submit" class="btn btn-primary" [disabled]="!form.controls.potential.valid"
                    (click)="submit()">
                    Submit
                  </button>
                </div>
              }
            </div>
          }
        }
      </form>
    </div>
  </div>
}
